import { AxiosResponse } from "axios";
import {
  ContactPersonDetailsDto,
  ContactPersonNoteDto,
  ContactPersonProjectDto,
  CreateContactPersonDto,
  CreateContactPersonNoteDto,
} from "../types/companyTypes";
import api from "../utils/api";

// CRUD endpoints for the standalone contact-person pages.
export const getAllContactPersons = async (): Promise<AxiosResponse<ContactPersonDetailsDto[]>> => {
  return await api.get<ContactPersonDetailsDto[]>("/companies/contact-persons");
};

export const getContactPersonById = async (
  contactPersonId: number
): Promise<AxiosResponse<ContactPersonDetailsDto>> => {
  return await api.get<ContactPersonDetailsDto>(`/companies/contact-persons/${contactPersonId}`);
};

export const createContactPerson = async (
  data: CreateContactPersonDto
): Promise<AxiosResponse<ContactPersonDetailsDto>> => {
  return await api.post<ContactPersonDetailsDto>("/companies/contact-persons", data);
};

export const updateContactPerson = async (
  contactPersonId: number,
  data: CreateContactPersonDto
): Promise<AxiosResponse<ContactPersonDetailsDto>> => {
  return await api.put<ContactPersonDetailsDto>(`/companies/contact-persons/${contactPersonId}`, data);
};

// Sub-resources shown on the contact-person detail page.
export const getContactPersonNotes = async (
  contactPersonId: number
): Promise<AxiosResponse<ContactPersonNoteDto[]>> => {
  return await api.get<ContactPersonNoteDto[]>(`/companies/contact-persons/${contactPersonId}/notes`);
};

export const createContactPersonNote = async (
  contactPersonId: number,
  data: CreateContactPersonNoteDto
): Promise<AxiosResponse<ContactPersonNoteDto>> => {
  return await api.post<ContactPersonNoteDto>(`/companies/contact-persons/${contactPersonId}/notes`, data);
};

export const getContactPersonProjects = async (
  contactPersonId: number
): Promise<AxiosResponse<ContactPersonProjectDto[]>> => {
  return await api.get<ContactPersonProjectDto[]>(`/companies/contact-persons/${contactPersonId}/projects`);
};
